import React from 'react';

const ProgressBar = ({ percentage }) => {
  const safePercentage = Math.max(0, Math.min(100, percentage));

  return (
    <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden shadow-inner">
      <div
        className="bg-blue-500 h-4 rounded-full transition-all duration-500 ease-out text-xs font-medium text-blue-100 text-center p-0.5 leading-none"
        style={{ width: `${safePercentage}%` }}
        role="progressbar"
        aria-valuenow={safePercentage}
        aria-valuemin="0"
        aria-valuemax="100"
      >
       {safePercentage > 10 ? `${safePercentage.toFixed(0)}%` : ''}
      </div>
    </div>
  );
};

export default ProgressBar;
